export default __webpack_public_path__ + "static/media/auth-background.c50a6fd7.jpg";